
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSimplifiedBeaconIsolatedDanger as ObiSimplifiedBeaconIsolatedDangerElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-simplified-beacon-isolated-danger.js';
 
 
 

 
 export const ObiSimplifiedBeaconIsolatedDanger = createComponent({
   react: React,
   tagName: 'obi-simplified-beacon-isolated-danger',
   elementClass: ObiSimplifiedBeaconIsolatedDangerElement,
   events: {
     
   }
  });
 
 